export type BufferedTimeRange = {
  start: number;
  end: number;
};

/**
 * Returns the first playable decoder timestamp when the playhead is stranded
 * before every appended HLS range. A playhead already in a range is left alone.
 */
export function getInitialBufferedPlayheadCorrection(
  currentTime: number,
  ranges: readonly BufferedTimeRange[],
): number | undefined {
  if (!Number.isFinite(currentTime) || ranges.length === 0) return undefined;
  if (ranges.some((range) => (
    Number.isFinite(range.start) &&
    Number.isFinite(range.end) &&
    range.start <= currentTime + 0.05 &&
    range.end >= currentTime
  ))) return undefined;
  const firstBufferedTime = ranges[0]?.start;
  if (
    !Number.isFinite(firstBufferedTime) ||
    firstBufferedTime <= currentTime + 0.25
  ) return undefined;
  return firstBufferedTime + 0.01;
}
